<template>
  <div>
    <CourseList
      @rowClicked="openCourseSubjectList"
      :appId="appId"
      :name="name"
    />
  </div>
</template>

<script lang='ts'>
/* eslint-disable import/no-cycle */
import { defineComponent } from 'vue';
import { APPIDS, SUBJECT_ROUTE_NAME } from '@/enums/';
import SubjectProvider from '@/providers/subject.provider';
import CourseList from '../../shared/components/CourseList.component.vue';

export default defineComponent({
  name: 'SubjectCourseList',
  components: { CourseList },
  provide() {
    return {
      Provider: SubjectProvider,
    };
  },
  data() {
    return {
      appId: APPIDS.SUBJECTS,
      name: 'SubjectCourseList',
    };
  },
  methods: {
    openCourseSubjectList(data) {
      this.$router.push({
        name: SUBJECT_ROUTE_NAME.LIST,
        params: {
          courseId: data.courseId,
        },
      });
    },
  },
});
</script>
